import type { AgentStatus, TeamMember } from "@shared/protocol";

const AVATAR_COLORS = ["bg-vermillion", "bg-blue", "bg-green", "bg-amber", "bg-violet"];

export function colorForUser(linuxUser: string): string {
  let h = 0;
  for (let i = 0; i < linuxUser.length; i++) h = (h * 31 + linuxUser.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length]!;
}

interface AvatarProps {
  member: TeamMember;
  size?: number;
  showPresence?: boolean;
  isSelf?: boolean;
}

export function Avatar({ member, size = 22, showPresence = true, isSelf = false }: AvatarProps) {
  return (
    <span
      className={`avatar ${colorForUser(member.linuxUser)} ${isSelf ? "self" : ""}`}
      style={{ width: size, height: size, fontSize: Math.max(9, size * 0.42) }}
    >
      {member.initials}
      {showPresence && member.online && <span className="presence" />}
    </span>
  );
}

interface StatusDotProps {
  status: AgentStatus;
  size?: number;
}

export function StatusDot({ status, size }: StatusDotProps) {
  return (
    <span
      className={`panel-status-dot ${status}`}
      style={size ? { width: size, height: size } : undefined}
    />
  );
}
